import React from "react";
import { UPDATE_AREA_SPECIFICATION } from "./jobState";
import { BASIC_SPECS_SECTIONS } from "./jobState_Schemas";
import { WarningIcon_Orange } from "./jobState_Validation";

// Returns relative str position in array
function searchStringInArray(str, strArray) {
    console.log(strArray);
    console.log(str);
    for (var j = 0; j < strArray.length; j++) {
        console.log(strArray[j]);
        if (strArray[j].includes(str)) return j;
    }
    return -1;
}

function findObjectKeyByRef2(objects, ref2) {
    for (let i = 0; i < objects.length; i++) {
        if (objects[i].Ref2 === ref2) {
            return i;
        }
    }
    return -1; // If the object with the given Ref2 is not found, return -1
}

export function bondorBrickworkWarning() {
    return (
        <div>
            {WarningIcon_Orange}A minimum of 1500mm of brickwork above the attachment point is required for Bondor
            Products. Continue at your own risk.
            <br />
        </div>
    );
}

export function insulatedSpanWarning({ job, sheetName, length, areaIndex, this_area, roofsheet, maxSpan }) {
    let message = [
        <>
            {
                "Please change Roofsheet, the structures size, remove the added purlin or contact support before proceeding."
            }
        </>,
    ];
    if (length > maxSpan * 2)
        message = [<>{"Please change Roofsheet, the structures size or contact support before proceeding."}</>];

    console.log(this_area);
    return {
        error: true,
        title: `Roofsheet '${sheetName}' cannot have multiple Purlins in a single Area.`,
        message,
        primaryActionText: "Cancel",
        secondaryActionText: `Change Depth to '${maxSpan * 2}mm'`,
        secondaryAction: () => {
            this_area["SHAPE"]["Depth"] = maxSpan * 2;
            return {
                type: UPDATE_AREA_SPECIFICATION,
                index: areaIndex,
                section: null,
                subsection: null,
                parameter: null,
                value: this_area,
                error: null,
            };
        },
    };
}

export function masonryBondorWarning({}) {
    return {
        error: true,
        title: `BONDOR ATTACHMENT REQUIREMENTS`,
        message: [
            <>
                {`You have selected to attach bondor to a masonry wall. 
                A minimum of 1500mm of brickwork (either concrete filled or tied down with anchor rods) 
                above the attachment point is required for Bondor Products.`}
                <br />
                <br />
                {`By clicking 'I Agree' you indemnify ${window.brand} against all liability for the decision to
                continue. If you have any doubts, select ‘Decline’ and seek the advice of a suitably
                qualified professional prior to continuing.`}
            </>,
        ],
        primaryActionText: "I Agree",
        secondaryActionText: "Decline",
        primaryAction: () => {
            // this_area["Footings"][findObjectKeyByRef2(this_area["Footings"], post)].Kind = "Concrete In";
            // return {
            //     type: UPDATE_AREA_SPECIFICATION,
            //     index: areaIndex,
            //     section: null,
            //     subsection: null,
            //     parameter: null,
            //     value: this_area,
            //     error: null,
            // };
        },
    };
}

export function postFootingWarning({ postName, footingType, areaIndex, this_area, post }) {
    return {
        error: true,
        title: `Post '${postName}' is not available in '${footingType}'.`,
        message: [<>{"Please change post, the structures footing type or contact support before proceeding."}</>],
        primaryActionText: "Cancel",
        secondaryActionText: "Change to 'Concrete In Ground'",
        secondaryAction: () => {
            this_area["Footings"][findObjectKeyByRef2(this_area["Footings"], post)].Kind = "Concrete In";
            return {
                type: UPDATE_AREA_SPECIFICATION,
                index: areaIndex,
                section: null,
                subsection: null,
                parameter: null,
                value: this_area,
                error: null,
            };
        },
    };
}

export function postNotchedWarning({ postName, areaIndex, this_area }) {
    return {
        error: true,
        title: `Post '${postName}' is not available in Notched.`,
        message: [<>{"Please change post, the structures post position or contact support before proceeding."}</>],
        primaryActionText: "Cancel",
        secondaryActionText: "Change to 'Post Behind Beam'",
        secondaryAction: () => {
            this_area[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CornerPostsFullHeight = 3;
            this_area[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].IntermediatePostsFullHeight = 3;
            return {
                type: UPDATE_AREA_SPECIFICATION,
                index: areaIndex,
                section: null,
                subsection: null,
                parameter: null,
                value: this_area,
                error: null,
            };
        },
    };
}

export function postHeightWarning({
    job,
    pos,
    maxPostHeight,
    confirmEngineeringAction,
    user,
    overrideEngineeringAction,
    postName,
    height,
    engValid,
}) {
    if (pos) {
        let postHeight = 0;
        const parsedHeight = parseInt(height, 10);
        const isHeightValid = !isNaN(parsedHeight);

        if (isHeightValid) {
            postHeight = parsedHeight;
        } else {
            // No {height} provided so search engineering results for the longest post of type {postName}
            const postsFromEngineering = job?.QuoteParameters?.ENGINEERING?.EngineeringResults?.ProcessedLoadData?.Cols;
            const postsArray = Object.values(postsFromEngineering || {});
            const postsFilteredByName = postsArray.filter((item) => item.ColumnType === postName);
            const postHeights = postsFilteredByName.map((item) => item.Height);
            const longestPost = postHeights.length > 0 ? Math.max(...postHeights) : null;

            // Fall back to building height if longest post can't be determined from engineering
            postHeight = longestPost !== null ? longestPost : job?.AreaSpecifications[0]?.SHAPE?.Height;
        }

        if (postHeight > maxPostHeight && !engValid) {
            return {
                error: true,
                title: `Post '${postName}' height exceeds maximum of ${maxPostHeight}mm.`,
                message: [<>{"Please modify the design or contact support before proceeding."}</>],
                primaryActionText: "Cancel",
                secondaryActionText: "Check Engineering",
                secondaryAction: confirmEngineeringAction,
                tertiaryActionText: user.Role >= 91 ? "Authorise Override?" : "",
                tertiaryAction: user.Role >= 91 ? overrideEngineeringAction : {},
            };
        }
    }
}

// Gets relative position of SL in the promptTextCode
export function getPos({ currentPOA, findPostProduct }) {
    let pos = searchStringInArray(currentPOA, findPostProduct[0]?.PromptTextCodes?.split(" "));
    if (pos === -1) pos = searchStringInArray("SL=", findPostProduct[0]?.PromptTextCodes?.split(" "));

    return pos;
}

// Gets the max height from POA and factors in extraCut (Concrete in -600 or Bolt to slab 100.)
export function getMaxPostHeight({ findPostProduct, pos, currentPOA, extraCut }) {
    let maxPostHeight = findPostProduct[0]?.PromptTextCodes?.split(" ")[pos].split("|").at(-1).split("(")[0];

    // Check if control code contains the region (i.e. SL_EMU=4000)
    if (maxPostHeight.includes(currentPOA)) {
        maxPostHeight = maxPostHeight.split(currentPOA + "=")[1];
    }

    maxPostHeight = parseInt(maxPostHeight, 10);

    if (isNaN(maxPostHeight)) {
        maxPostHeight = 0;
    }

    maxPostHeight -= extraCut;

    // Ensure this function doesn't return a negative number
    maxPostHeight = Math.max(0, maxPostHeight);

    return maxPostHeight;
}

// Helper to convert string to function
export function createConditionFunction(conditionStrings) {
    // Combine all condition strings into one
    const combinedCondition = conditionStrings.join(" && ");
    console.log(combinedCondition);
    return (props) => {
        return new Function("props", `return (${combinedCondition});`)(props);
    };
}

export function interpolate(template, data) {
    console.log(data);
    return template.replace(/{([^{}]*)}/g, (a, b) => {
        return Function("data", "with(data) { return " + b + "}")(data);
    });
}
